//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ReportImprovementProposedEmployees from './ReportImprovementProposedEmployees.vue'
import { convertTime } from '../../components/helpers.js'
import { mapGetters } from 'vuex'

// const DATE_TIME_FORMAT = 'DD-MM-YYYY hh:mm'
const parseDate = function (value) {
  const pattern = /(\d{2})-(\d{2})-(\d{4})\s(\d{2}):(\d{2})/
  return new Date(value.replace(pattern, '$3-$2-$1T$4:$5:00'))
}

export default {
  components: {
    ReportImprovementProposedEmployees: ReportImprovementProposedEmployees
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    type: {
      type: String,
      default: 'text'
    },
    isAudit: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      selectedEmployee: null,
      hideEmployee: false,

      header: null,
      opened: false,
      text: null,
      time: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    selectedEmployeeName: function () {
      if (this.selectedEmployee != null) {
        if (this.selectedEmployee.type === 'list') {
          return this.selectedEmployee.value.map(employee => this.getEmployeeName(employee)).join(', ')
        }
        return this.getEmployeeName(this.selectedEmployee.value)
      }
      return ''
    }
  },
  methods: {
    ask: function (callback) {
      this.callback = callback
      this.header = this.report.multiReport ? 'Доработка сводного отчёта' : 'Доработка отчёта'
      if (!this.selectedEmployee) {
        this.selectedEmployee = {
          type: 'self',
          value: this.user.employee ? this.user.employee : this.user,
          valueKey: this.user.employee ? this.user.employee.id : this.user.login
        }
      }
      if (this.report.actionsAccess.reworkReportByExecutor) {
        this.text = 'По решению исполнителя'
        this.hideEmployee = true
      } else {
        this.text = this.report.defaultRemark
        this.$nextTick(() => {
          this.load()
        })
      }
      this.opened = true
    },
    confirm () {
      let value
      if (this.type === 'text') {
        value = this.text ? this.text.slice() : ''
      } else if (this.type === 'datetime') {
        value = this.time != null ? parseDate(this.time).getTime() : null
      }
      this.opened = false
      this.clearValue()

      if (this.isAudit) {
        this.callback({
          reworkReason: value,
          deferred: false,
          deferralTime: null
        })
      } else if (this.selectedEmployee) {
        this.callback({
          comment: value,
          improvementsExecutor: this.$refs.executorSelector.getSelectedExecutorData(this.selectedEmployee)
        })
      } else {
        this.$q.notify({
          type: 'negative',
          message: 'Не выбран исполнитель',
          progress: true,
          timeout: 5000
        })
      }
    },
    load: function () {
      this.$refs.executorSelector.load((employee) => {
        this.selectedEmployee = employee
      })
    },
    close () {
      this.opened = false
      this.clearValue()
    },
    clearValue () {
      this.text = ''
      this.time = null
    },
    showProposedExecutors: function () {
      this.$refs.executorSelector.select((employee) => {
        this.selectedEmployee = employee
      }, false)
    },
    formatDateTime: function (millis) {
      return millis !== undefined ? convertTime(millis) : ''
    },
    getEmployeeName: function (employee) {
      if (employee.fio || employee.name) {
        const fio = employee.fio || employee.name
        const names = fio.split(' ')
        let name = names[0]
        if (names[1] && names[1].length) {
          name += ' ' + names[1][0] + '.'
        }
        if (names[2] && names[2].length) {
          name += names[2][0] + '.'
        }
        return name
      }
      return JSON.stringify(employee.id)
    }
  }
}
